const isStop = (event: Stop | Move): event is Stop => {
  return 'point' in event ? event.point !== undefined : false;
};

export default isStop;
